import React from 'react';
import { connect } from 'react-redux';

import { propExistsAndNonEmpty , getQueryParameters, serializeQueryParameters } from '../../util/utils';
import * as path from '../../util/pathConstructor';

import { fetchResults } from '../../actions/resultActions';
import LoadingCard from '../shared/loadingCard/loadingCard';

const mapStateToProps = (state) => {
    return {
        assessment: state.app.assessment,
        selectedFilters: state.session.selectedFilters.inResults,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchResults: (indexName) => dispatch(fetchResults(indexName))
    };
};

class Loading extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            done: undefined
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        if (propExistsAndNonEmpty(this.props.assessment)) {
            const { name } = this.props.assessment;
        
            setTimeout(() => {
                this.props.fetchResults(name)
                    .then(res => this.setState({ done: true }))
                    .catch(res => this.setState({ done: true }));
            }, 1000);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.done !== this.state.done) {
            return true;
        }

        return false;
    }

    componentDidUpdate(prevProps) {
        const { assessment, location, selectedFilters } = this.props;
        const qs = getQueryParameters(location.search);

        if (selectedFilters.length > 0) {
            const filters = selectedFilters.join(',');
            qs.q = filters;
        }

        const resultsPath = path.getResultsPath(assessment.name, '?' + serializeQueryParameters(qs));
        this.props.history.push(resultsPath);
    }

    render() {
        const { assessment } = this.props;

        let loadingCopy = 'Finding your results...';

        if (propExistsAndNonEmpty(assessment)) {
            loadingCopy = assessment.loadingConfig.copy;
        }

        return (
            <LoadingCard copy={loadingCopy}/>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Loading);